import gql from 'graphql-tag';

export const mockExamSchoolStatus = gql`
  query mockExamSchoolStatus($roundCode: ID!, $locationCode: ID!) {
    mockExamSchoolStatus(mockExamRoundCode: $roundCode, mockExamLocationCode: $locationCode) {
      locationCode
      roundCode
      availableExams {
        id
        roundCode
        locationCode
        locationName
      }
    }
  }
`;
